module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "INTRO"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.xxvi"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.1"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("“The quintessence and perfection of saving doctrine.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.1.1",
      "id": "FN.1.1r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" This description of Romans by Thomas Draxe, a seventeenth-century English Puritan, has been echoed by theologians, commentators, and laypeople throughout the centuries. When we think of Romans, we think of doctrine. Moreover, this response is both understandable and appropriate. As we will see, Paul’s letter to the Romans is thoroughly doctrinal: the “purest Gospel,” as Luther put it."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.1.2",
      "id": "FN.1.2r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" But, like every book in the NT, Romans is rooted in history. It is not a systematic theology but a letter, written in specific circumstances and with specific purposes. The message of Romans is, indeed, timeless; but to understand its message aright, we must appreciate the specific context out of which Romans was written. In the pages that follow, I want to fill out this context as a basis for my interpretation and application of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.1"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.1"
    }
  }, [_vm._v("I. GENERAL CIRCUMSTANCES")])]), _vm._v(" "), _c('p', {
    staticClass: "bhaft",
    attrs: {
      "id": "INTRO.1.1"
    }
  }, [_vm._v("A. PAUL")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Romans claims to be written by Paul (1:1), and there has been no serious challenge to this claim. In keeping with regular ancient custom, Paul used an amanuensis, or scribe, to write the letter, identified in 16:22 as Tertius. Ancient authors gave to their amanuenses varying degrees of responsibility in the composition of their works—from word-for-word recording of what they "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.2"
    }
  }), _vm._v("dictated to quite sweeping responsibility for putting ideas into words. Paul’s method in Romans is certainly far toward the “dictation” end of this spectrum. For the style of Romans is very close to that of Galatians and 1 Corinthians—and we have no evidence that Tertius was involved in the composition of either of these letters (indeed, see Gal. 6:11).")]), _vm._v(" "), _c('p', [_vm._v("If the authorship of Romans is not in doubt, neither is the general situation in which it was written. Paul tells us in 15:22–29 that three localities figure in his immediate plans: Jerusalem, Rome, and Spain. Jerusalem is his immediate destination. Paul has completed his collection of money from his largely Gentile churches and is now on his way to Jerusalem to deliver the money to the Jewish saints there. This collection was an important project for Paul, as may be gauged from the fact that he talks about it in every letter written on the third missionary journey (cf. also 1 Cor. 16:1–4; 2 Cor. 8–9). Its importance goes beyond meeting the material needs of the poor Christians in Judea; Paul views it as a practical way to cement the fractured relationship between the Gentile churches of the mission field and the Jewish churches in the “home” country. In chap. 15 Paul demonstrates his concern about how this collection will be received by the “saints” in Jerusalem. Will they accept the gift and so acknowledge the links that bind Jewish and Gentile believers together in one people of God? Or will they reject it, out of suspicion of Paul and the “law-free” churches he has planted?")]), _vm._v(" "), _c('p', [_vm._v("Rome is the second stage in Paul’s itinerary (15:24, 28). But, while sincere in his desire to visit the Christians in Rome, Paul views Rome as little more than a stopping-off point in his projected journey to Spain. This is not to minimize the importance of the Christian community in Rome but reflects Paul’s understanding of his call: “to preach the gospel in regions where Christ has not yet been named” (15:20). This task of initial church-planting is one that Paul has completed in the eastern Mediterranean: “from Jerusalem and as far around as Illyricum [modern-day Albania and the former Yugoslavia] I have ‘fulfilled’ the gospel of Christ” (15:19). As a result of the first three missionary journeys, churches have been planted in major metropolitan centers throughout southern and western Asia Minor (Tarsus, Pisidian Antioch, Lystra, Iconium, Derbe, and Ephesus), Macedonia (Philippi and Thessalonica), and Greece (Corinth). These churches can now take responsibility for evangelism in their own areas, while Paul sets his sights on virgin gospel territory in the far western end of the Mediterranean.")]), _vm._v(" "), _c('p', [_vm._v("When we compare these indications with Luke’s narrative in Acts, it is clear that Romans must have been written toward the end of the third missionary journey, when Paul, accompanied by representatives from the churches he had founded, prepared to return to Jerusalem (Acts 20:3–6). Since Luke tells us that Paul spent three months in Greece before beginning his homeward journey, we can also surmise that while staying here, with the next "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.3"
    }
  }), _vm._v("stage of his missionary career about to unfold, Paul wrote his letter to the Romans. It was probably in Corinth that Paul stayed while in Greece (see 2 Cor. 13:1, 10); and that Romans was written from here is suggested by the fact that Paul commends to the Romans a woman, Phoebe, from Cenchrea, a seaport adjacent to Corinth (16:1–2). Moreover, the Gaius with whom Paul is apparently staying (16:23) is probably the same Gaius whom Paul baptized at Corinth (1 Cor. 1:14). (And is the city-treasurer Erastus who sends greetings to the Romans [16:23] the same Erastus who is identified in an inscription as an "), _c('i', [_vm._v("aedile")]), _vm._v(" [city commissioner] at Corinth?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.3",
      "id": "FN.3.3r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(") The date at which Romans was written will depend, accordingly, on the dating of Paul’s three-month stay in Greece; and this dating, in turn, is dependent on the hazardous process of constructing an absolute chronology of the life of Paul. The best alternative is probably "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 57,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.4",
      "id": "FN.3.4r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿4")]), _vm._v(" though leeway of a year or two either way must be allowed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.3.5",
      "id": "FN.3.5r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', [_vm._v("What emerges as especially significant from this sketch of Paul’s own situation is that he writes his letter to the Romans at an important transition point in his missionary career. For almost twenty-five years, Paul has planted churches in the eastern Mediterranean. Now he prepares to bring to Jerusalem a practical fruit of that work, one that he hopes will heal the most serious social-theological rift in the early church—the relationship between Jew and Gentile in the people of God. Beyond Jerusalem, Spain, with its “fields ripe for the harvesting,” beckons. On the way is Rome.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.1.2"
    }
  }, [_vm._v("B. THE CHRISTIAN COMMUNITY IN ROME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("In reconstructing Paul’s situation when he wrote Romans, we can build on his own statements in Romans, as well as on the evidence from his other letters and from the book of Acts. We have no such direct evidence to use in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.4"
    }
  }), _vm._v("reconstructing the situation of the Christian community in Rome at the time of Paul’s letter. Its origin is obscure and its composition and nature in Paul’s day unclear.")]), _vm._v(" "), _c('p', [_vm._v("The tradition that the church in Rome was founded by Peter (or Peter and Paul together) cannot be right."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.6",
      "id": "FN.4.6r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" It is in this very letter that Paul enunciates the principle that he will “not build on another person’s foundation” (15:20). This makes it impossible to think that he would have written this letter, or planned the kind of visit he describes in 1:8–15, to a church that was founded by Peter. Nor is it likely that Peter could have been at Rome early enough to have founded the church there. Since the traditions we possess associate no other apostle with the church at Rome, the assessment of the fourth-century church father Ambrosiaster is probably correct: the Romans “have embraced the faith of Christ, albeit according to the Jewish rite, without seeing any sign of mighty works or any of the apostles.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.7",
      "id": "FN.4.7r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" The most likely scenario is that Roman Jews, who were converted on the day of Pentecost in Jerusalem (see Acts 2:10), brought their faith in Jesus as the Messiah back with them to their home synagogues. In this way the Christian movement in Rome was initiated.")]), _vm._v(" "), _c('p', [_vm._v("Ambrosiaster is probably also right, then, when he identifies the synagogue as the starting point for Christianity in Rome. Enough Jews had emigrated to Rome by the end of the first century "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("B.C.")]), _vm._v(" to make up a significant portion of the population."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.8",
      "id": "FN.4.8r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" They were not bound together in any single organizational structure. Their many synagogues apparently were independent of one another."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.4.9",
      "id": "FN.4.9r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" An important event in the history of the Jews in Rome is mentioned by the Roman historian Suetonius. In his "), _c('i', [_vm._v("Life of Claudius,")]), _vm._v(" he says that Claudius “expelled the Jews from Rome because they were constantly rioting at the instigation of Chrestus” (25.2). Most scholars agree that “Chrestus” is a corruption of the Greek "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Christos")]), _vm._v(" and that the reference is probably to disputes within the Jewish community over the claims of Jesus to be the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.5"
    }
  }), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Christos,")]), _vm._v(" the Messiah. There is less agreement over whether the fifth-century writer Orosius is right in dating this incident in "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 49. But the date is probably correct"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.10",
      "id": "FN.5.10r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿10")]), _vm._v(" and receives incidental confirmation from Acts 18:2, where Luke says that Aquila and Priscilla had recently come to Corinth from Italy “because Claudius had commanded all the Jews to leave Rome.” As with similar expulsions of specific groups from Rome, this one did not stay in force for long. Jews, like Aquila and Priscilla (cf. Rom. 16:3), were able to return to Rome within a short period of time, certainly soon after Claudius’s death in "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 54.")]), _vm._v(" "), _c('p', [_vm._v("Nevertheless, since the Roman authorities would not have distinguished between Jews and Jewish Christians, this expulsion, however temporary, must have had a significant impact on the development of the church at Rome. Specifically, the Gentile element in the churches, undoubtedly present before the expulsion, would have come into greater prominence as a result of the absence for a time of all (or virtually all) the Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.11",
      "id": "FN.5.11r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Theologically this would also have meant an acceleration in the movement of the Christian community away from its Jewish origins. The decentralized nature of the Jewish community from which the Christian community sprang would also make it likely that the Christians in Rome were grouped into several house churches. Confirmation that this was the case comes from Rom. 16, where Paul seems to greet several different house churches."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.12",
      "id": "FN.5.12r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" It is also possible, though more speculative, that these different house churches were divided theologically."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.5.13",
      "id": "FN.5.13r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.2"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.2"
    }
  }, [_vm._v("II. INTEGRITY, LITERARY HISTORY, AND TEXT")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Is the letter to the Romans as it is now printed in our Bibles identical to the letter that Paul sent to the Christians in Rome? Many scholars answer no. Of these a few base their conclusions on internal literary considerations alone. Two scholars, for instance, conclude that internal inconsistencies within Romans can be explained only if our present letter is composed of two or more "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.6"
    }
  }), _vm._v("separate letters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.14",
      "id": "FN.6.14r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" Others have identified interpolations in the text: single verses, or more, that have been added to the letter after the time of Paul."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.15",
      "id": "FN.6.15r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" But none of these theories can be accepted. They have no textual basis, and Romans has none of those somewhat awkward transitions that have led scholars to question the integrity of other Pauline letters.")]), _vm._v(" "), _c('p', [_vm._v("But a more serious question is raised by the textual evidence. This evidence has led a significant number of scholars to think that the 16-chapter form of the letter we have in our Bibles was not the form of the letter that Paul sent to the Roman Christians. We can begin by listing the several forms of the text as it appears in the "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" tradition:")]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_vm._v("1. 1:1–14:23, 15:1–16:23, 16:25–27: P"), _c('sup', [_vm._v("61")]), _vm._v("?, "), _c('span', {
    staticClass: "heb"
  }, [_vm._v("א")]), _vm._v(", B, C, D, 1739, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("2. 1:1–14:23, 16:25–27, 15:1–16:23, 16:25–27: A, P, 5, 33, 104")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("3. 1:1–14:23, 16:25–27, 15:1–16:24: "), _c('span', {
    staticClass: "grc"
  }, [_vm._v("Ψ")]), _vm._v(", the “majority” text, sy"), _c('sup', [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("4. 1:1–14:23, 15:1–16:24: F, G [archetype of D?], 629")]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("5. 1:1–14:23, 16:24–27: vg"), _c('sup', [_vm._v("1648,1792,2089")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_vm._v("6. 1:1–15:33, 16:25–27, 16:1–23: P"), _c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', [_vm._v("Ostensibly, the major problem is whether the doxology (16:25–27) should be included, and if so, where—at the end of chap. 14, chap. 15, or chap. 16? If this were the extent of the problem, we would be faced with a relatively minor textual question. But the different placements of the doxology combine with other textual and literary issues to raise serious questions about the origin and literary history of this letter as a whole. As can be seen above, for instance, several "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" of the Latin Vulgate omit 15:1–16:23 entirely, an omission for which evidence is also found in another Vulgate codex"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.6.16",
      "id": "FN.6.16r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿16")]), _vm._v(" and in the absence of reference to chaps. 15 and 16 in "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.7"
    }
  }), _vm._v("Tertullian,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.17",
      "id": "FN.7.17r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" Irenaeus, and Cyprian. All this raises the possibility that the 16-chapter form of the letter we now have in our Bibles is secondary to an original 14- or 15-chapter form. When we add to this the fact that a few "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" (G and the Old Latin g) omit the only references to Rome that occur in the letter (1:7, 15), we can understand why various theories of a shortened and more “universal” form of the letter have arisen.")]), _vm._v(" "), _c('p', [_vm._v("Lake, for instance, argues that Paul’s original letter was made up of chaps. 1–14 and that he added chap. 15 when he sent it to Rome."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.18",
      "id": "FN.7.18r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" But a more popular theory is that the original letter, addressed to Rome, consisted of 1:1–15:33. In both reconstructions, however, chap. 16 is considered to be no part of Paul’s letter to the Romans. This conclusion, which is quite widespread, is based on both textual and literary considerations. The placement of the doxology after chap. 15 in P"), _c('sup', [_vm._v("46")]), _vm._v(" can be accounted for, it is argued, only if the letter had at one time ended there.")]), _vm._v(" "), _c('p', [_vm._v("But more important is the internal evidence of chap. 16 itself. The warning about people causing dissensions in 16:17–20 seems out of place with chaps. 1–15. Particularly striking are the extensive greetings in vv. 3–15. In addition to Phoebe, Paul greets twenty-five individuals, two families, one “church,” and an unspecified number of “fellow believers” and “saints”—all these in a community that he had never visited. Surely chap. 16, it is argued, must be addressed to a church that Paul knows well—Ephesus being the best candidate because Paul singles out for a greeting “the first convert in Asia” (16:5; Ephesus was in the Roman province of Asia) and because we last meet Aquila and Priscilla there (Acts 18:19). According to one variation of this interpretation, chap. 16 was a separate letter of commendation for Phoebe."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.19",
      "id": "FN.7.19r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" According to another view, associated particularly with T. W. Manson, the chapter was added when Paul sent a copy of his original letter to Rome (chaps. 1–15) to Ephesus."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.7.20",
      "id": "FN.7.20r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.8"
    }
  }), _vm._v("These theories, however, are almost certainly wrong."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.21",
      "id": "FN.8.21r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")]), _vm._v(" Although there is definite evidence of a 14-chapter form of Romans in the early church,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.22",
      "id": "FN.8.22r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" the intimate connection between chaps. 14 and 15 makes it impossible to think that Paul’s original letter was without chap. 15."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.23",
      "id": "FN.8.23r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿23")]), _vm._v(" How, then, did the 14-chapter form of the letter originate? Lightfoot thought that Paul himself may have abbreviated his letter to the Romans, omitting the references to Rome in 1:7 and 1:15 at the same time, in order to universalize the epistle."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.24",
      "id": "FN.8.24r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")]), _vm._v(" But it is unlikely that, had this been Paul’s purpose, he would have cut off his epistle in the middle of his argument."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.25",
      "id": "FN.8.25r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")]), _vm._v(" The same objection applies to Gamble’s theory that the text of Romans was shortened after Paul’s time in order to make the letter more universally applicable."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.26",
      "id": "FN.8.26r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")]), _vm._v(" The earliest explanation for the shortened form is given by Origen, who claims that Marcion cut off "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(dissecuit)")]), _vm._v(" the last two chapters. Since this explanation offers the best rationale for breaking off the letter at 15:1 (for there is much from 15:1 onward that would have offended Marcion’s anti-Jewish sentiments), I tentatively adopt it as the most likely explanation for the 14-chapter form of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.27",
      "id": "FN.8.27r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', [_vm._v("What, then, of the alleged 15-chapter form? Textually, this theory is on shaky ground from the outset, for there is no single "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(" of Romans that contains only 15 chapters. Its only textual evidence is the placement of the doxology in P"), _c('sup', [_vm._v("46")]), _vm._v(" after chap. 15; but P"), _c('sup', [_vm._v("46")]), _vm._v(" does not omit chap. 16. Furthermore, the internal arguments for omitting the chapter are not strong. The last-minute warning about false teachers in vv. 17–20 has some parallel with Paul’s procedure in other letters; and the special circumstances of Romans explain why it occurs only here."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.8.28",
      "id": "FN.8.28r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" The number of people greeted poses a greater problem. But the expulsion of the Jews and Jewish Christians from Rome would have given Paul opportunity to meet a number of these people (like "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.9"
    }
  }), _vm._v("Priscilla and Aquila) during the time of their exile in the east. It has even been argued that Paul would be more likely to greet individuals by name in an unfamiliar church where he knew only those whom he greeted than to risk offending the majority by greeting only selected members in a church he knew well."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.29",
      "id": "FN.9.29r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")]), _vm._v(" At any rate, the problem posed by the number of greetings is not great enough to overcome the external evidence in favor of including chap. 16 in Paul’s original letter to the Romans.")]), _vm._v(" "), _c('p', [_vm._v("We conclude that the letter Paul wrote to Rome contained all sixteen chapters found in modern texts and translations."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.30",
      "id": "FN.9.30r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.3"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.3"
    }
  }, [_vm._v("III. AUDIENCE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("As we have seen, Christianity in Rome began among Jews (see “General Circumstances”). And, although the expulsion under Claudius eliminated the Jewish element in the church for a time, we can be certain that by the date of Romans at least some Jewish Christians (like Priscilla and Aquila) would have returned. We have no direct knowledge of the origins of Gentile Christianity in Rome; but, if the pattern of the Pauline mission was followed, we can surmise that “God fearers,” Gentiles who were interested in Judaism and attended synagogue without becoming Jews,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.9.31",
      "id": "FN.9.31r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" were the first to be attracted to the new faith. Certainly by the date of Romans Gentiles made up a significant portion of the church in Rome (cf. 11:13–32 and 15:7–12). We may, then, be fairly certain that when Paul wrote Romans the Christian community in Rome was made up of both Jewish and Gentile Christians. This does not necessarily mean, however, that Paul had both groups in mind as he wrote his letter. It is to the evidence of the letter that we must turn to determine the audience.")]), _vm._v(" "), _c('p', [_vm._v("Unfortunately, the letter appears to send out mixed signals on this issue. On the one hand, there is evidence to suggest that Paul had Jewish Christians in mind as he wrote: (1) he greets the Jewish-Christians Priscilla and Aquila and his “kinfolk” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(syngeneis)")]), _vm._v(" Andronicus, Junia, and Herodion in chap. 16 (vv. 3, 7, 11); (2) he directly addresses “the Jew” in chap. 2 (cf. v. 17); (3) he "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.10"
    }
  }), _vm._v("associates his readers closely with the Mosaic law (6:14: “you are no longer under the law”; 7:1: “I am speaking to those who know the law”; 7:4: “you have died to the law”); (4) he calls Abraham “"), _c('i', [_vm._v("our")]), _vm._v(" forefather according to the flesh” (4:1); and (5) he spends much of the letter on issues of special interest to the Jewish people: their sin and presumption of divine favor (2:1–3:8), the failure of their law (3:19–20, 27–31; 4:12–15; 5:13–14, 20; 6:14; 7; 8:2–4; 9:30–10:8), the significance of Abraham their “forefather” (chap. 4), and their place in the unfolding plan of God (chaps. 9–11).")]), _vm._v(" "), _c('p', [_vm._v("Indications of a Gentile-Christian audience are also, however, evident: (1) in his address for the letter as a whole, Paul includes the Roman Christians among the Gentiles to whom he has been called to minister (1:5–6; cf. also 1:13 and 15:14–21); (2) Paul claims that his argument about the place of Jews in God’s plan (11:11–24) is directed “to you Gentiles” (v. 13; and note the second person plurals throughout vv. 14–24); (3) Paul’s plea to “receive one another” in 15:7 appears to be directed especially to Gentile Christians (cf. vv. 8–9).")]), _vm._v(" "), _c('p', [_vm._v("We appear to be faced with a paradox. As Kümmel puts it, “Romans manifests a double character: it is essentially a debate between the Pauline gospel and Judaism, so that the conclusion seems obvious that the readers were Jewish Christians. Yet the letter contains statements which indicate specifically that the community was Gentile-Christian.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.10.32",
      "id": "FN.10.32r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")]), _vm._v(" Several options are open to us.")]), _vm._v(" "), _c('p', [_vm._v("First, we may dismiss or downplay the evidence of a Gentile-Christian readership and conclude that the letter is addressed solely, or at least mainly, to Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.10.33",
      "id": "FN.10.33r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")]), _vm._v(" But this will not do. Rom. 11:13 may suggest that Gentiles are only one part of the church, but 1:5–6 cannot be evaded (by, for instance, translating “among whom [Gentiles] you [Roman Christians] are located”—see the exegesis). This verse, standing in the introduction to the "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.11"
    }
  }), _vm._v("letter, suggests strongly that Paul regarded his addressees as Gentile Christians.")]), _vm._v(" "), _c('p', [_vm._v("A much better case can be made, then, for the view that Paul’s readers were Gentile Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.34",
      "id": "FN.11.34r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" Not only does 1:5–6 appear to be decisive, but the evidence for a Jewish-Christian readership is not particularly strong. The greetings in chap. 16 show that there were Jewish Christians in the Roman community, but they do not require that the letter be addressed to them. The second singular address in Rom. 2 is a literary device and reveals nothing about the actual readers of the letter (see the introduction to 2:1–3:8). When Paul calls Abraham “our” forefather (4:1), he may be including with himself other Jews or Jewish Christians rather than his readers. That Paul associates his readers with the law is clear; but, as we argue (see the notes on 6:14 and 7:4), Paul thinks that Gentiles are “under the law” in some sense. And, even in 14:1–15:13, where reference to Jewish Christians can probably not be excluded, Paul’s argument is directed mainly to the “strong in faith.”")]), _vm._v(" "), _c('p', [_vm._v("Finally, while some of the letter is, indeed, a debate, or dialogue, with Judaism (e.g., 1:18–4:25), it is not necessary that Jews or Jewish Christians be the intended audience for the debate. Paul’s purpose may be to rehearse the basic issues separating Jews and Christians and to show what his gospel has to say about them, with the purpose of helping Gentile Christians understand the roots of their faith and their own situation vis-à-vis both Jews and Jewish Christians."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.35",
      "id": "FN.11.35r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(" This purpose certainly becomes evident in chaps. 9–11, where Paul sketches the place of Israel in salvation history to stifle the arrogance of the Gentiles. Galatians, too, demonstrates clearly enough that teaching about the failure of the law and the inadequacy of circumcision was necessary for Gentile Christians to hear."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.11.36",
      "id": "FN.11.36r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")]), _vm._v(" Moreover, the Gentiles themselves would have had a more personal interest in these matters than we have sometimes realized. For, as we have suggested, Christianity in Rome began in the synagogue, and the first Gentiles converted were almost certainly “God-fearing” synagogue attenders. This Jewish matrix for Christianity in Rome meant that even Gentile Christians would have “known the law” (7:1) "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.12"
    }
  }), _vm._v("and that many of them would likely have been curious about how the gospel related to their previous understanding of circumcision and the law."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.12.37",
      "id": "FN.12.37r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', [_vm._v("Although this interpretation of the data is generally satisfactory, it must be questioned whether we can eliminate Jewish Christians entirely from Paul’s audience. Paul claims in 1:7 that he is addressing “"), _c('i', [_vm._v("all")]), _vm._v(" those beloved of God in Rome,” and it is clear that there were Jewish Christians in Rome. Moreover, Paul’s exhortation to the “strong” and the “weak” makes best sense if both groups—roughly equivalent to Gentile and Jewish Christians respectively—were in his audience. And, while Paul’s “dialogue with Judaism” in 1:18–4:25 and his sketch of the inadequacy of the law in chap. 7 can be accounted for on the basis of a solely Gentile audience, we must wonder whether these texts are not more adequately explained if there were at least some Jewish Christians in Paul’s audience. These considerations make it likely that the audience to which Paul writes was composed of both Jewish and Gentile Christians.")]), _vm._v(" "), _c('p', [_vm._v("Granted such a mixed audience, it is possible to suppose that Paul directs different parts of his letter to different groups within the Roman church. The most elaborate and best-defended version of this viewpoint is that of Paul Minear. He distinguishes five separate groups in the community, attributing each section of the letter to one or another of these groups."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.12.38",
      "id": "FN.12.38r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")]), _vm._v(" While providing a salutary reminder that the community in Rome should not be simplistically divided into two groups according to ethnic origin, Minear’s thesis goes beyond the evidence. The existence of several of his groups is unclear, and the progressive flow of Paul’s argument in the letter renders a constant shifting in audience unlikely. This means that, with certain exceptions (e.g., 11:13–24), we must assume that Paul has the whole community, a mixed group of Jewish and Gentile Christians, in mind as he writes.")]), _vm._v(" "), _c('p', [_vm._v("Along with the majority of commentators, then, we think that Paul addresses a mixed group of Jewish and Gentile Christians in Romans. Some "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.13"
    }
  }), _vm._v("decline to estimate the relative proportion of the two groups,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.39",
      "id": "FN.13.39r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")]), _vm._v(" but the considerations advanced above show that Gentile Christians were in the majority, perhaps an overwhelming majority."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.40",
      "id": "FN.13.40r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")]), _vm._v(" There is, however, one major problem with this reconstruction: Why, if there were Jewish Christians in the community, and especially if they were being slighted by the Gentile-Christian majority (cf. 11:13–24), would Paul have addressed the community as a "), _c('i', [_vm._v("Gentile")]), _vm._v(" one (1:5–6)?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.41",
      "id": "FN.13.41r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")]), _vm._v(" The answer is probably that the community as a whole had by this date taken on the complexion of Gentile Christianity."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.42",
      "id": "FN.13.42r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" Indeed, it is perhaps just this shift from the earlier Jewish matrix of Roman Christianity to a more purely “Gentile” framework (a process accelerated by the enforced exile of Jewish Christians under Claudius) that has given rise to a sense of inferiority on the part of the Jewish segment. Moreover, the purpose of Paul in 1:5–6 (and 1:13) is not so much to identify the national complexion of the community as to locate it within the scope of his commission to the Gentiles. These texts, then, do not stand in the way of the conclusion that the audience Paul addresses in Romans is made up of a Gentile-Christian majority and a Jewish-Christian minority.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.4"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.4"
    }
  }, [_vm._v("IV. NATURE AND GENRE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Romans is, of course, an epistle, but what kind? Many types of letters were written in the ancient world, ranging from brief, intimate, and informal notes to friends and family members to carefully crafted treatises designed for a large audience. Where within this range we should situate the Pauline letters has been much debated, but they clearly fall somewhere between these extremes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.13.43",
      "id": "FN.13.43r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" Even the Pauline letters addressed to individuals—1 and 2 Timothy, Titus, and Philemon (though cf. v. 2)—have broadly pastoral purposes. And the most general of his letters—Ephesians and Romans—are not only addressed to specific communities (at least in their present form) but also include material, like greetings to individuals, that would be of limited interest.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.14"
    }
  }), _vm._v("Nevertheless, while Romans displays clear evidence of its “occasional” nature in its epistolary opening (1:1–15 [–17]) and closing (15:14–16:27), the really striking feature of the letter is the general and sustained argument of 1:16–11:36. Unlike, for instance, 1 Corinthians, where Paul’s agenda is set by questions and issues raised by his readers, these chapters in Romans develop according to the inner logic of Paul’s own teaching. Even the questions and objections that periodically interrupt the argument arise naturally from the flow of Paul’s presentation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.44",
      "id": "FN.14.44r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")]), _vm._v(" Not once in these chapters does Paul allude to a circumstance peculiar to the community at Rome, and even the direct addresses of his audience are so general as to be applicable to almost any church: “fellow believers” (7:4; 8:12; 10:1; 11:25), “those who know the law” (7:1), “you Gentiles” (11:13). Nor does the situation change much in 12:1–15:13. None of the issues addressed is clearly local or particular in scope. Some even argue that the section about the “strong” and the “weak” (14:1–15:13) has no specific local situation in view."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.45",
      "id": "FN.14.45r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', [_vm._v("These features show that the main body of Romans is what we may call a “treatise,” or “tractate.” It addresses key theological issues against the backdrop of middle first-century Christianity rather than within the context of specific local problems. Nevertheless, Romans is no timeless treatise. We must not forget that Romans as a whole is a "), _c('i', [_vm._v("letter,")]), _vm._v(" written on a specific occasion, to a specific community. As we have seen, these specifics have not played a large role in Paul’s presentation, but they have undoubtedly determined the agenda of theological and practical issues with which Paul deals. In this regard, we must note that Romans is far from being a comprehensive summary of Paul’s theology. Many issues near and dear to him are absent, or only allusively mentioned: the church as the “body of Christ,” the parousia, and Christology (in the “formal” sense). Moreover, the issues that Paul does treat are oriented to a specific, though broad, theological topic: the relationship between Jew and Gentile, law and gospel (see, further, the section on “Theme” below).")]), _vm._v(" "), _c('p', [_vm._v("Romans, then, is a tractate letter and has at its heart a general theological argument, or series of arguments."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.14.46",
      "id": "FN.14.46r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")]), _vm._v(" More specific genre identification is perilous. R. Bultmann compared Romans to the “diatribe,” an argumentative "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.15"
    }
  }), _vm._v("genre particularly popular with Cynic-Stoic philosophers (the best example is probably the "), _c('i', [_vm._v("Discourses")]), _vm._v(" of Epictetus, 1st-2d "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.CENT"
    }
  }, [_vm._v("cent.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(")."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.47",
      "id": "FN.15.47r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")]), _vm._v(" Features of the diatribe include “fictional” conversations and debates, rhetorical questions, and the use of "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("mē genoito")]), _vm._v(" (“may it never be!”)"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.48",
      "id": "FN.15.48r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")]), _vm._v(" to reject a line of argument. Bultmann thought that the diatribe had a polemical purpose and read Romans accordingly. But S. Stowers argues that instruction and clarification rather than polemics were the purposes of the diatribe."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.49",
      "id": "FN.15.49r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")]), _vm._v(" Recent research also suggests that “diatribe” was not so much a genre as a style."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.50",
      "id": "FN.15.50r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" In any case, while parts of Romans use this diatribe style (e.g., 2:1–3:8), the letter as a whole cannot be classified as a diatribe.")]), _vm._v(" "), _c('p', [_vm._v("Scholars have suggested many other genre classifications for Romans: “memorandum,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.51",
      "id": "FN.15.51r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" “epideictic” letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.52",
      "id": "FN.15.52r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")]), _vm._v(" ambassadorial letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.53",
      "id": "FN.15.53r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")]), _vm._v(" “protreptic letter,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.54",
      "id": "FN.15.54r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")]), _vm._v(" and “letter essay,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.55",
      "id": "FN.15.55r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")]), _vm._v(" to name only a few. None quite fits. Certainly Romans has similarities to these genres and to a large number of other ancient Hellenistic and Jewish genres and styles. But these resemblances mean nothing more than that Paul has effectively utilized various literary conventions of his culture to get his message across. Romans cannot finally be put into any single genre; as Dunn says, “the distinctiveness of the letter far outweighs the significance of its conformity with current literary or rhetorical custom.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.15.56",
      "id": "FN.15.56r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.5"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.16"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.5"
    }
  }, [_vm._v("V. PURPOSE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The interesting mixture of the general and the occasional outlined in the last section gives rise to one of the most debated questions about Romans: Why has Paul written "), _c('i', [_vm._v("this")]), _vm._v(" letter to "), _c('i', [_vm._v("this")]), _vm._v(" particular church?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.16.57",
      "id": "FN.16.57r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" This question can, of course, be bypassed by those who view Romans as a timeless theological treatise, a “compendium of Christian doctrine” (Melanchthon). But, however general and systematic its presentation may be, Romans is a letter, and the question of why Paul has written it cannot be evaded.")]), _vm._v(" "), _c('p', [_vm._v("The question of the purpose of Romans has been given so many different answers because Paul says almost nothing on the subject. In the introduction (1:1–15), Paul talks about his plans to visit Rome and preach the gospel there, but he says nothing about the purpose of the letter. The conclusion of the letter elaborates these plans to come to Rome. Having “completed” his mission in the eastern Mediterranean, Paul is going next to Jerusalem to deliver the collection, and from there he plans to visit Rome on his way to Spain. But about the purpose of the letter he says only that he “has written on some points by way of reminder” (15:15). This statement is so general and stereotyped that little can be gleaned from it.")]), _vm._v(" "), _c('p', [_vm._v("Paul’s purpose in writing, then, can be determined only by fitting the contents of the letter with its occasion. We have sketched the general occasion for the letter earlier in the introduction and, briefly, in the last paragraph. But it is the specific occasion, in the sense of Paul’s motivation for writing, that will give us the clue to the purpose of the letter. Opinions on this matter may be divided into two basic types: (1) those that stress Paul’s own situation and circumstances as the occasion for Romans; and (2) those that focus on problems within the Roman community as the occasion for the letter. Few scholars completely ignore either of these occasions; but their reconstructions differ in the degree of importance accorded to each one.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.5.1"
    }
  }, [_vm._v("A. FOCUSING ON PAUL’S CIRCUMSTANCES")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Alternatives that focus on circumstances within Paul’s own situation as his motivation for writing to the Romans may be conveniently, if somewhat simplistically, categorized by reference to the "), _c('i', [_vm._v("location")]), _vm._v(" that is Paul’s focus.")]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.17"
    }
  }), _vm._v("1. Spain")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Most scholars, whatever weight they give to other circumstances, think that one of Paul’s purposes in writing to the Romans was to prepare for his mission to Spain. A church-planting enterprise so far from Paul’s home base in Antioch would create all kinds of logistical problems. It would be natural for Paul to try to enlist the help of the vital and centrally located Roman community for this mission. In fact, Paul alludes to his hopes for such support in 15:24, using the verb "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("propempō,")]), _vm._v(" which connotes “help on the way with material support.” We may, then, view Romans as Paul’s “letter of introduction” to a church that he hopes to add to his list of “sponsors.” This would explain the general theological focus of the letter, for Paul would want to assure the Romans that they would be sponsoring a missionary whose orthodoxy was without question."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.17.58",
      "id": "FN.17.58r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', [_vm._v("Preparation for the mission to Spain was certainly one of Paul’s purposes in writing, probably even a major purpose. But it cannot stand alone as an explanation for the epistle. For one thing, had this been Paul’s sole concern, we would have expected him to mention the visit to Spain more prominently—in the introduction, not just in the conclusion of the letter. For another, it is difficult on this interpretation to account for Paul’s focus on questions of Jew and Gentile within salvation history.")]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_vm._v("2. Corinth/Galatia")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("One way of accounting for this emphasis on Jewish issues is to regard Romans as Paul’s summary of the position he had hammered out in the course of his struggle with Judaizers in Galatia and Corinth. Paul’s three-month stay in Greece came after the resolution of intense battles for the gospel in these churches; before he enters a new stage of missionary work, with fresh challenges and problems, Paul may well have decided to put in writing his settled views on these issues. Supporting this way of viewing the matter is the neutral and balanced stance that Paul in Romans takes on issues such as the law and circumcision—a balance that suggests no particular viewpoint was forcing Paul into a polemical position on these matters."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.17.59",
      "id": "FN.17.59r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.18"
    }
  }), _vm._v("Again, there is probably much to this suggestion. But it leaves too much unexplained. Most important, why send this “last will and testament” (as Bornkamm calls it) to Rome?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.60",
      "id": "FN.18.60r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('p', {
    staticClass: "ch"
  }, [_vm._v("3. Jerusalem")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The same objection applies to the suggestion that Romans contains the “speech” that Paul is preparing to deliver in Jerusalem when he arrives with the collection. As we have seen, Paul viewed this collection as a practical means to cement the fractured and sometimes bitter relationships between Jews and Gentiles in the early church. And, since Paul expressly requests the Romans to pray for the success of this mission (15:30–33), what is more natural than that he would outline his own theological position on the issue to the church?"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.61",
      "id": "FN.18.61r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" Paul’s impending visit to Jerusalem clearly loomed large in his mind as he wrote Romans. But there is no evidence that it was his overriding concern. Moreover, both this suggestion and the last fail to come to grips with Paul’s stress on his desire to visit the community in Rome—an emphasis in both the introduction and conclusion to the letter. Surely this suggests that the letter had something specific to do with this planned visit.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.5.2"
    }
  }, [_vm._v("B. FOCUSING ON PROBLEMS IN ROME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("F. C. Baur inaugurated a new approach to Romans by insisting, against the prevalent tendency to consider Romans as a timeless theological manifesto, that this letter, like all the other letters of Paul, must be directed to specific issues in the church addressed."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.62",
      "id": "FN.18.62r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")]), _vm._v(" To be sure, Paul had never visited the church in Rome. But there is sufficient evidence that he was acquainted with the situation there (see 1:8; 7:1; 11:13; 14–15; Prisca and Aquila would have been good sources of information)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.18.63",
      "id": "FN.18.63r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")]), _vm._v(" Baur’s general approach has enjoyed a resurgence in the last three decades. However, though Baur thought Romans had "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.19"
    }
  }), _vm._v("a polemical purpose, contesting the claims of Jewish Christians, modern scholars have focused on other concerns as primary.")]), _vm._v(" "), _c('p', [_vm._v("G. Klein thinks that Paul wrote with the purpose of providing the necessary apostolic foundation for the creation of a “church” in Rome. Significant, according to Klein, is the absence of the word “church” "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("(ekklēsia)")]), _vm._v(" from the address of the letter (1:7). The Christians in Rome lacked the apostolic “imprimatur” that was necessary to constitute a church. In Romans, Paul provides this apostolic stamp of approval by rehearsing the “fundamental kerygma” that would turn a Christian community into a Christian church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.64",
      "id": "FN.19.64r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")]), _vm._v(" Klein’s thesis does not stand up to scrutiny. Paul’s failure to address the Romans as a church proves nothing; Philippians, Colossians, and Ephesians share the same omission."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.65",
      "id": "FN.19.65r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" More fundamentally, however, Klein’s supposition that a church could not exist without a "), _c('i', [_vm._v("personal")]), _vm._v(" “apostolic foundation” is baseless.")]), _vm._v(" "), _c('p', [_vm._v("Most of those who think that Paul writes with the needs of the Roman church uppermost in his mind seize on the implications of 14:1–15:13 as the key to the purpose of the letter. This passage reveals a split in the Roman community between Jewish and Gentile Christians. Here it is, many scholars think, that we find the central concern of the letter. The treatise in chaps. 1–11 supplies the theological basis for Paul’s appeal for unity in chaps. 14–15, while chaps. 12–13 provide its general parenetic basis. According to F. Watson, Paul writes specifically to convert the Jewish Christians in the community to his view of a “law-free” gospel so that they will separate completely from Judaism and join the Gentile Christians in forming one Pauline congregation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.66",
      "id": "FN.19.66r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")]), _vm._v(" It is more popular, though, to view Romans as addressed to both Jewish and Gentile Christians, with the emphasis, if anything, on the latter group. This fits better with both the focus on Gentiles in the letter (1:5–6, 13; 11:13—see above) and the probably increasingly dominant position of Gentiles in the church. Paul would then be writing to correct the Gentiles’ indifference, even arrogance, toward the Jewish minority at the same time that he tries to show the Jews that they must not insist on the law as a normative factor in the church."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.19.67",
      "id": "FN.19.67r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.20"
    }
  }), _vm._v("We think that Paul does, indeed, write with an eye on specific problems in the community at Rome. What he says in 14:1–15:13 is too specific to allow us to consider it as general “paraenesis,” with no direct application to the Roman community."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.68",
      "id": "FN.20.68r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")]), _vm._v(" And his direct address of Gentiles in 11:13–24 shows that Paul intends the theology he is developing to have direct practical relevance to his audience. But we also think that the divisions in the Roman church mirrored the tensions of the church at large in Paul’s day. It would be going too far to say that the specific problem in Rome gave Paul a good excuse to write about this widespread tension. But it is the case that Romans is far less tied to issues bound up with a particular church than is any other Pauline letter (with the possible exception of Ephesians). We have noted that the major part of the body of Romans, chaps. 1–11, develops by its own internal logic: Paul’s focus is on the gospel and its meaning rather than on the Romans and their needs."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.69",
      "id": "FN.20.69r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" The complete omission of any direct reference to the Romans until 11:13 makes it very difficult to think that the problems of the Roman church were foremost in Paul’s mind. Then, too, there is much in this treatise that does not relate to the situation implied in chaps. 14 and 15. Nor is it fair to argue that Romans must be directed to the needs of the congregation in the same way that Paul’s other letters are. For one thing, Romans stands apart, by definition, as being the only letter Paul wrote to a church for which he did not have established “pastoral” responsibility."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.70",
      "id": "FN.20.70r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")]), _vm._v(" For another, we have too few letters of Paul to make black-and-white judgments about the kind of letter he could or could not have written.")]), _vm._v(" "), _c('p', [_vm._v("The purpose of Paul in Romans, then, cannot be confined to any one of these suggestions; Romans has several purposes."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.71",
      "id": "FN.20.71r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")]), _vm._v(" But the various purposes share a common denominator: Paul’s missionary situation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.20.72",
      "id": "FN.20.72r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" The past battles in Galatia and Corinth; the coming crisis in Jerusalem; the desire to secure a missionary base for his work in Spain; the need to unify the Romans around “his” gospel to support his work in Spain—all these forced Paul to write a letter in which he carefully rehearsed his understanding of the gospel, especially "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.21"
    }
  }), _vm._v("as it related to the salvation-historical questions of Jew and Gentile and the continuity of the plan of salvation."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.73",
      "id": "FN.21.73r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', [_vm._v("There may have been another reason for Paul to give such prominence to these particular issues. Paul’s battle against Judaizers (cf. Galatians; 2 Corinthians) had gained for him a reputation as being “anti-law” and perhaps even “anti-Jewish.” Rumors of Paul’s stance on these matters had probably reached Rome, as 3:8 might suggest (Paul mentions people who are “blasphemously” charging him with saying, “Let us do evil that good may come”). As Paul introduces his gospel to the Roman community, he is aware that he must defuse these rumors and perhaps even win over some who were already hostile toward him."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.74",
      "id": "FN.21.74r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")]), _vm._v(" But, unlike the situations he faced in Galatia and elsewhere, at Rome these doubts about Paul and his gospel did not, apparently, come from only one side."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.21.75",
      "id": "FN.21.75r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" As 14:1–15:13 suggests, he was contending both with Jewish Christians who were still tied to the law and with Gentile Christians who scorned everything Jewish—and very likely with a number of intermediate positions. Hence Paul fights on two fronts: criticizing Judaism for its overemphasis on the law and its presumption of “most favored nation” status, while affirming Israel as the “root” of the church and emphasizing its continuing place within the plan of God.")]), _vm._v(" "), _c('p', [_vm._v("One more thing about the occasion and purpose of Romans should be mentioned. The legitimate desire to pin down as precisely as possible the historical background and purpose of the letter should not obscure the degree to which Romans deals with theological issues raised by the nature "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.22"
    }
  }), _vm._v("of God’s revelation itself. Perhaps the earliest comment on the purpose of Romans comes in the Muratorian Canon ("), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 200?): “to the Romans he [Paul] wrote at greater length [than in Corinthians or Galatians], concerning the plan of the Scriptures, showing at the same time that their foundation is Christ.”")]), _vm._v(" "), _c('p', [_vm._v("We moderns must beware the tendency to overhistoricize: to focus so much on specific local and personal situations that we miss the larger theological and philosophical concerns of the biblical authors."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.76",
      "id": "FN.22.76r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" That Paul was dealing in Romans with immediate concerns in the early church we do not doubt. But, especially in Romans, these issues are ultimately those of the church—and the world—of all ages: the continuity of God’s plan of salvation, the sin and need of human beings, God’s provision for our sin problem in Christ, the means to a life of holiness, and security in the face of suffering and death."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.77",
      "id": "FN.22.77r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")]), _vm._v(" Augustine, Luther, Calvin, and Wesley, whatever their failings as exegetes, saw this; and perhaps they understood more clearly than many of their latter-day critics."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.78",
      "id": "FN.22.78r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" We need to recognize that Romans is God’s word to "), _c('i', [_vm._v("us")]), _vm._v(" and read it seeking to discover the message that God has for us in it. As Luther said, “[Romans] is worthy not only that every Christian should know it word for word, by heart, but occupy himself with it every day, as the daily bread of the soul. It can never be read or pondered too much, and the more it is dealt with the more precious it becomes, and the better it tastes.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.22.79",
      "id": "FN.22.79r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.6"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.6"
    }
  }, [_vm._v("VI. THEME")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("At the risk of oversimplification, we can chart the history of the discussion of the theme of Romans as a movement from a focus on the beginning of the epistle to its end. The Reformers and their followers, following the lead of Luther, almost universally gave pride of place to chaps. 1–5, with their "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.23"
    }
  }), _vm._v("theme, justification by faith, as the center of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.80",
      "id": "FN.23.80r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")]), _vm._v(" At the beginning of this century, however, Schweitzer and others argued that justification by faith was no more than a “battle doctrine” "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("(Kampflehre),")]), _vm._v(" a theological concept that Paul used simply to oppose Judaizers. The real center of Paul’s thinking is to be found in chaps. 5–8, in his doctrine of union with Christ and the work of God’s Spirit."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.81",
      "id": "FN.23.81r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")]), _vm._v(" Others objected to the traditional focus on justification by faith because they thought that it illegitimately read back into Paul’s day a modern and Western preoccupation with the individual and his conscience. “How can a sinful person be made right with God?” was Luther’s problem, but it was not Paul’s. Rather, the question Paul sought to answer was: “How can Gentiles be incorporated with Jews into God’s people without jeopardizing the continuity of salvation history?” For these scholars, Rom. 9–11, far from being a detour from the real theme of the letter,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.82",
      "id": "FN.23.82r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")]), _vm._v(" was the heart of the letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.83",
      "id": "FN.23.83r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" Finally, as we have seen, the last thirty years have witnessed an emphasis on Romans as an occasional letter, directed to the needs of the Roman church. For many of those who advocate this approach to the letter, Paul’s exhortation to unity in 14:1–15:13 expresses the major purpose of the letter (see above on Purpose).")]), _vm._v(" "), _c('p', [_vm._v("Forms of each of these positions are argued in the current literature on Romans. H. Hübner and others have vigorously reasserted, against its critics, the centrality of justification in Romans and in Paul generally."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.84",
      "id": "FN.23.84r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")]), _vm._v(" In the approach associated especially with E. Käsemann, justification language is subsumed under the category of “the righteousness of God,” interpreted broadly to mean God’s intervention to reclaim his creation for himself and to bring salvation to his people."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.23.85",
      "id": "FN.23.85r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")]), _vm._v(" Indeed, he claims that this interpretation is the theme "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.24"
    }
  }), _vm._v("of Romans. E. P. Sanders has reemphasized the importance of the “participationist” categories of Rom. 5–8."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.86",
      "id": "FN.24.86r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("﻿86")]), _vm._v(" Perhaps the most popular recent viewpoint is that Romans is about the role of Jews in salvation history."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.87",
      "id": "FN.24.87r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")]), _vm._v(" Many other focal points for the letter have also been advocated: “God,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.88",
      "id": "FN.24.88r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")]), _vm._v(" “hope,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.89",
      "id": "FN.24.89r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")]), _vm._v(" and “salvation,”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.24.90",
      "id": "FN.24.90r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" to name only a few.")]), _vm._v(" "), _c('p', [_vm._v("Before commenting on these proposals, two cautions are in order. First, we must be careful not to impose on Romans a single theme when Paul may never have thought in those terms. It is true that the tractate nature of the letter encourages the supposition that Paul may have had a single overarching theme in view. But such a supposition is not necessary, particularly when we recognize that the tractate style recedes into the background after chap. 11. In other words, a theme that fits 1:16–11:36 may not fit the letter as a whole. Romans may, then, have several themes without having any single, unifying topic. Second, we must define what we mean when we talk about "), _c('i', [_vm._v("the")]), _vm._v(" “theme,” or “center,” of the letter. Do we mean the doctrine that serves to ground and unify the various topics of the letter, the theological framework of Paul’s thinking, or the most important, or critical, topic in the letter—or something else? Some of the debate on this issue is no more than shadow-boxing, because scholars are confusing categories and are not arguing about the same thing.")]), _vm._v(" "), _c('p', [_vm._v("To avoid confusion, we will define “theme” as the overarching topic that is able to stand as the heading of Romans as a whole. Before further exploring the issue of theme per se, we need to comment on some of the related issues that we raised above.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.1"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.25"
    }
  }), _vm._v("A. THE THEOLOGICAL STARTING POINT")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Christology is the theological ground and starting point of the letter. Paul’s understanding of Christ is the only topic broad enough to unify his various emphases. And, though no paragraph is devoted to Christology per se in the doctrinal portion of the letter, we must not neglect the importance of Rom. 1:3–4, where Paul describes the content of his gospel in terms of Christology."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.25.91",
      "id": "FN.25.91r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")]), _vm._v(" Other passages make God’s act in Christ the center of God’s eschatological revelation (3:21–26; 5:12–21), and all the topics in the letter are grounded in Christ (note the constant refrain in chaps. 5–8: “through Jesus Christ our Lord”). God’s act in Christ is the starting point of all Paul’s thinking and is so basic to the early church that he could assume that the Roman Christians shared this conviction with him. In this sense, while Christology is nowhere in Romans the expressed "), _c('i', [_vm._v("topic,")]), _vm._v(" it is everywhere the underlying point of departure.")]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.2"
    }
  }, [_vm._v("B. THE CONCEPTUAL FRAMEWORK")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Second, the theological framework within which Paul expresses his key ideas in Romans can be called salvation history. The phrase “salvation history,” or “redemptive history” ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.GERM"
    }
  }, [_vm._v("Germ.")]), _vm._v(" "), _c('span', {
    staticClass: "l-ger-i"
  }, [_vm._v("Heilsgeschichte")]), _vm._v("), is used to designate several different and sometimes contradictory concepts. We are using the phrase in a rather untechnical fashion to denote a conceptual framework that Paul uses to describe what has taken place in Christ. In focusing on Paul, we do not intend to confine the conception exclusively to him; on the contrary, it is basic to the NT and perhaps the OT as well."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.25.92",
      "id": "FN.25.92r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.26"
    }
  }), _vm._v("Justification for the salvation-historical approach begins with due appreciation for the fact that God has accomplished redemption as part of a historical process. God’s work in Christ is the center of history, the point from which both past and future must be understood. The cross and resurrection of Christ are both the fulfillment of the OT and the basis and anticipation of final glory. With Christ as the climax of history, then, history can be divided into two “eras,” or “aeons,” each with its own founder—Adam and Christ, respectively—and each with its own ruling powers—sin, the law, flesh, and death on the one hand; righteousness, grace, the Spirit, and life on the other. All people start out in the “old era” by virtue of participation in the act by which it was founded—the sin of Adam (cf. Rom. 5:12, 18–19). But one can be transferred into the “new era” by becoming joined to Christ, the founder of that era, thereby participating in the acts through which that era came into being—Christ’s death, burial, and resurrection (cf. 6:1–6). This "), _c('i', [_vm._v("corporate")]), _vm._v(" element in Paul’s thinking is vital to understanding his argument at a number of points in Romans.")]), _vm._v(" "), _c('p', [_vm._v("The division of history into two ages was popular in Jewish apocalyptic, and Paul probably drew his conception from that background. But his understanding of God’s work in Christ introduces a key qualification in the scheme. Although Jewish apocalyptic conceived of the transition from old age to new as taking place in the field of actual history, Paul’s conception is necessarily more nuanced. For, contrary to Jewish expectation, the Messiah has accomplished the work of redemption, the Spirit has been poured out, yet evil has not been eradicated, the general resurrection is still future, and the final state of God’s kingdom has not been established. In other words, the new era has begun—has been inaugurated—but it has not yet replaced the old era. Both ages exist simultaneously; and this means that “history,” in the sense of temporal sequence, is not ultimately determinative in Paul’s salvation-historical scheme."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.26.93",
      "id": "FN.26.93r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")]), _vm._v(" Thus, the “change of aeons,” while occurring historically at the cross (cf. 3:21), becomes real for the individual only at the point of faith. The “change of aeons” that took place in Christ is experienced only “in Christ.” Therefore, the person who lives "), _c('i', [_vm._v("after")]), _vm._v(" Christ’s death and resurrection and who has not appropriated the benefits of those events by faith lives in the old era yet: enslaved to sin, in the flesh, doomed to eternal death. On the other hand, Abraham, for example, though living many centuries "), _c('i', [_vm._v("before")]), _vm._v(" Christ, must, in light of Rom. 4, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.27"
    }
  }), _vm._v("be considered to belong, in some sense at least, to the new era. This circumstance introduces a confusing factor, making it difficult to come up with an overall system that is capable of integrating all of Paul’s applications of salvation history. At this point, however, it is important to recall that, while rooted in the nature of God’s redemptive work, the salvation-historical scheme we have delineated is largely a useful conceptual tool for Paul, a tool that he uses to make different points in different places."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.94",
      "id": "FN.27.94r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")]), _vm._v(" But it serves Paul well in Romans, where it perfectly serves his purpose to make clear the finality and uniqueness of the gospel as well as its connections with the revelation of God in the OT."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.95",
      "id": "FN.27.95r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('p', {
    staticClass: "bh",
    attrs: {
      "id": "INTRO.6.3"
    }
  }, [_vm._v("C. THE THEME")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The trend in recent scholarship to make the relationship of Jews and Gentiles within the new covenant people of God central to Romans is understandable and, to a considerable extent, justified. For Romans is permeated with concern for the Jews, their law, and their relationship to the revelation of the righteousness of God and to the increasingly Gentile-oriented church. The word “law,” usually referring to the Mosaic law, occurs more times in Romans (74) than in all the other letters of Paul combined (47); Paul devotes an entire chapter to it (7), and it recurs in relationship to almost every topic Paul treats (cf., e.g., 2:12–16; 4:13–15; 5:13–14, 20; 6:14, 15; 8:2–4; 9:31–10:5; 13:8–10)."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.27.96",
      "id": "FN.27.96r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")]), _vm._v(" Because the law is central to the Mosaic covenant, Paul’s discussion of law becomes a discussion of the Mosaic covenant and its relationship to the New Covenant initiated in Christ. Rom. 9–11 is no excursus then, but brings to a climax a theme that has been present in the letter since its opening verses: “the gospel of God which he promised beforehand through his prophets in the holy scriptures” (1:1b-2). For the issue of the Jew is, finally, the issue of continuity in God’s salvation plan and, consequently, of God’s faithfulness to his promises (cf. 3:1–8; 9:6). In Romans, Paul teaches both the newness of God’s intervention in Christ—which means a “no” to the law and the Mosaic covenant as permanent features of salvation history—and the connections between the new act and the OT—which means a “yes” to the Abrahamic promise and to the future of Israel. Paul, then, both denies to the Jew "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.28"
    }
  }), _vm._v("an “advantage” (3:9) and affirms that Israel has certain inalienable rights (3:1–2; 11:11–32); affirms the universality of God’s righteousness—“to "), _c('i', [_vm._v("all")]), _vm._v(" who believe”—and its particular relevance to the Jew—“to the Jew first”; and claims that the righteousness of God has been revealed “apart from the law” (3:21) and that the gospel first provides for the true fulfillment of the law (3:31; 8:4). These are not contradictions but the two sides of the relationship of continuity and discontinuity between the testaments that Paul sets forth in Romans. We can understand, then, why many scholars call Romans a “dialogue with Judaism.”"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.28.97",
      "id": "FN.28.97r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" "), _c('p', [_vm._v("But to make the relationship between the two peoples—Jews and Gentiles—the theme of Romans, with the transformation of the individual a subordinate, supporting concept, is to reverse their relationship in the letter, to confuse background with foreground. The scholars who have put “people” questions at the center of Romans have overreacted to the neglect of these matters among some earlier interpreters. The bulk of Romans focuses on how God has acted in Christ to bring the "), _c('i', [_vm._v("individual")]), _vm._v(" sinner into a new relationship with himself (chaps. 1–4), to provide for that "), _c('i', [_vm._v("individual’s")]), _vm._v(" eternal life in glory (chaps. 5–8), and to transform that "), _c('i', [_vm._v("individual’s")]), _vm._v(" life on earth now (12:1–15:13). Since it is essential to Paul’s message that God acts, in a way that he has not previously, to include on an equal basis both Jew and Gentile in this transforming operation, Paul must pay constant attention to the implications of this new equality of treatment. He must explain how his message of individual transformation relates to God’s focus on Israel in the OT. This explanation thus becomes a constant motif in the letter and occupies an important section of the letter (chaps. 9–11) in its own right. But it remains the background, as Paul presents in the foreground the way in which God has acted to transform rebellious sinners into obedient saints.")]), _vm._v(" "), _c('p', [_vm._v("Is, then, justification by faith the theme of the letter? Certainly a good case can be made for it. But I do not finally think that it can stand as the overarching theme. This is not because I would thereby be foisting an anachronism on Paul. The individual and his relationship to God are important in Romans; and there is not as much difference between the thought world of Paul and that of Luther or ourselves as Stendahl and others think."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.28.98",
      "id": "FN.28.98r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")]), _vm._v(" On the other hand, there is too much in Romans that cannot, without distortion, be subsumed under the heading of justification: the assurance "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.29"
    }
  }), _vm._v("and hope of the believer (chaps. 5 and 8); freedom from sin and the law (chaps. 6 and 7); God’s purpose for Israel (chaps. 9–11); and the life of obedience (chaps. 12–15). To be sure, we can relate all of these to justification, as its fruits, or implications, or requirements; and Paul makes this connection himself at several points (cf. 5:1, 9; 8:33; cf. 9:30–10:8). But he does not do so often enough to make us think that justification, or “the righteousness of God,” is his constant reference point. In fact, as we have implied above, it is only in 1:18–4:25 that justification is highlighted in Romans.")]), _vm._v(" "), _c('p', [_vm._v("But while it is not the theme of Romans, justification by faith is nevertheless of critical importance in the letter. For, as we will argue below, the theme of the letter is the gospel. And the message of the gospel is that God brings guilty sinners into relationship with himself and destines them to eternal life when they believe in his son, Jesus the Messiah. Moreover, this message is nothing more than what we call justification by faith. And justification by faith is central to Romans and to Paul’s theology also because it expresses, in the sphere of anthropology, a crucial element in Paul’s understanding of God’s work in Christ: its entirely gracious character. Justification by faith is the necessary implicate of the grace of God (e.g., 4:5, 16). Not only, then, does justification by faith guard against the Jewish attempt to make works of the law basic for salvation in Paul’s day; it expresses the resolute resistance of Paul, and the NT authors, to the constant human tendency to make what people do decisive for salvation. It is in this sense, then, that we uphold justification as a doctrine of critical importance in Romans."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.29.99",
      "id": "FN.29.99r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', [_vm._v("What, then, is the theme of the letter? The gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.29.100",
      "id": "FN.29.100r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")]), _vm._v(" The word “gospel” and the cognate verb “evangelize” are particularly prominent in the introduction (cf. 1:1, 2, 9, 15) and conclusion (15:16, 19) of Romans—its epistolary “frame.” And this is the word that has pride of place in Paul’s statement of the theme of the letter: 1:16–17. “For I am not ashamed of the gospel.…” True, Paul goes on to speak of the interplay of salvation, "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.30"
    }
  }), _vm._v("the interplay of Jew and Gentile, and justification by faith; and each has been advanced as the theme of the letter. But they are all elaborations of the main topic of these verses, the gospel."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.101",
      "id": "FN.30.101r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")]), _vm._v(" And we require a theme as broad as “the gospel” to encompass the diverse topics in Romans. Moreover, as we have seen, Romans grows out of Paul’s own missionary situation; and the gospel Paul preaches would naturally be the focus of attention in any letter that arises from such a situation. Romans is Paul’s summary of the gospel that he preaches. But because he writes this summary in a context charged with uncertainty and controversy over the gospel’s relationship to the OT—especially the torah—and its embrace of both Jew and Gentile, he nuances his summary with constant reference to these issues.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.7"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.7"
    }
  }, [_vm._v("VII. TEXT AND TRANSLATION")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("The textual basis for the commentary is the United Bible Societies’ "), _c('i', [_vm._v("The Greek New Testament,")]), _vm._v(" fourth edition (which prints the same text as the Nestle-Aland "), _c('span', {
    staticClass: "lang-i"
  }, [_vm._v("Novum Testamentum Graece,")]), _vm._v(" twenty-seventh edition). Readers may find discussion of every variant cited in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(" in the footnotes to the translations; I have also discussed a number of significant variants that do not appear in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("The Greek "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" witnesses to the text of Romans are:")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_vm._v("Papyri")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("P"), _c('sup', [_vm._v("46")]), _vm._v(", “Chester Beatty II.” This very early ("), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.C"
    }
  }, [_vm._v("c.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("A.D.")]), _vm._v(" 200) papyrus codex exhibits what Aland and Aland call a “free” text,"), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.102",
      "id": "FN.30.102r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")]), _vm._v(" one that does not clearly line up consistently with any of the “families” that developed at a later period."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.30.103",
      "id": "FN.30.103r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")]), _vm._v(" It unfortunately includes only parts of Romans: 5:17–6:14; 8:15–15:9; 15:11–16:27.")]), _vm._v(" "), _c('p', [_vm._v("The other papryi witnesses to the text of Romans (P"), _c('sup', [_vm._v("10, 26, 27, 31, 40, 61, 94")]), _vm._v(") include only small parts of the letter.")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.31"
    }
  }), _vm._v("Uncials")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_c('span', {
    staticClass: "heb"
  }, [_vm._v("א")]), _vm._v(" (01), “Sinaiticus.” This is one of the great fourth-century uncials, containing the entire NT (as well as most of the OT and Apocrypha). It is a primary witness to the Alexandrian text.")]), _vm._v(" "), _c('p', [_vm._v("A (02), “Alexandrinus.” This fifth-century "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(" contains most of the NT, including all of Romans, and is a slightly less valuable witness to the Alexandrian text (Aland and Aland’s category II).")]), _vm._v(" "), _c('p', [_vm._v("B (03), “Vaticanus.” With Sinaiticus, Vaticanus is the most important witness to the Alexandrian textual tradition. It contains most of the NT, including all of Romans.")]), _vm._v(" "), _c('p', [_vm._v("C (04), “Ephraemi Rescriptus.” A fifth-century palimpsest, it contains most of Romans and is a secondary witness to the Alexandrian text.")]), _vm._v(" "), _c('p', [_vm._v("D (06), “Claromontanus.” To be distinguished from the “D” uncial of the Gospels and Acts (Bezae), this sixth-century uncial is one of the most important witnesses to the western text in Romans. It lacks only a few verses of Rom. 1.")]), _vm._v(" "), _c('p', [_vm._v("F (010), “Augiensis.” A ninth-century witness to the western text, it contains all of Romans except chaps. 1–2 and parts of chap. 3.")]), _vm._v(" "), _c('p', [_vm._v("G (012), “Boernerianus.” This ninth-century "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(", containing all of Romans except parts of chaps. 1 and 2, has a text very close to that of “F.” They might well be “sister” "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(", copied from the same (now lost) "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MS"
    }
  }, [_vm._v("MS")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("P (025), “Porphyrianus.” Containing most of Romans, this ninth-century codex displays a text that does not line up consistently with any of the major textual families (Aland and Aland’s category III).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "grc"
  }, [_vm._v("Ψ")]), _vm._v(" (044), “Athous Lavrensis.” This eighth- or ninth-century uncial, like P, is not a consistent witness to any text family. It includes all of Romans.")]), _vm._v(" "), _c('p', [_vm._v("Several other uncials contain all or most of Romans: K (018), L (020), 049, 056, 0142, and 0151. But they are late (ninth century or later) and are part of what textual critics call the “majority text.”")]), _vm._v(" "), _c('p', {
    staticClass: "dh"
  }, [_vm._v("Minuscules")]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Twenty-nine minuscules contain all or part of the text of Romans. The three most important are 33 (ninth century), 81 (eleventh century), and 1739 (tenth century), all of which are important secondary witnesses to the Alexandrian text."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.31.104",
      "id": "FN.31.104r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.32"
    }
  }), _vm._v("All the important witnesses identified above will be cited (where extant and relevant) as we deal with variants in the text of Romans. Following the practice of "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.NA"
    }
  }, [_vm._v("NA")]), _c('sup', [_vm._v("27")]), _vm._v(" and "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(", I will cite the majority of late "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.MSS"
    }
  }, [_vm._v("MSS")]), _vm._v(" that belong to the Byzantine text by reference to the “majority text” (= “Byz” in "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0007#ABBR.UBS"
    }
  }, [_vm._v("UBS")]), _c('sup', [_vm._v("4")]), _vm._v(").")]), _vm._v(" "), _c('p', [_vm._v("The translation printed at the heading of each section is my own. It is very literal, my purpose being to give the non-Greek-speaking reader as much sense as possible of the structure and ambiguity of the underlying Greek.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.8"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.8"
    }
  }, [_vm._v("VIII. STRUCTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "paft"
  }, [_vm._v("Because the main body of Romans is a “theological tractate,” outlines of the structure of the letter tend to resemble the headings in systematic theologies. Beker has objected to this procedure, arguing that the pursuit of a “systematic thought structure” imposes an “architectonic rigor” on what is, after all, an occasional letter."), _c('span', {
    staticClass: "fnref",
    attrs: {
      "href": "#/eernicnt66ro0012#FN.32.105",
      "id": "FN.32.105r",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" To the extent that scholars subsume everything in the letter under a single theological doctrine (e.g., justification by faith), or attach the labels of later dogmatic structures to the letter (e.g., dividing Rom. 1–8 into the topics of justification and sanctification, or making predestination the topic of chaps. 9–11), or ignore the occasional and practical elements in the letter (especially chaps. 12–16), this objection is warranted. But this should not deter us from searching for logical movement in the letter, especially in chaps. 1–11, where, as we have seen, the course of Paul’s argument owes more to the “inner logic” of the gospel than to occasional matters. In these chapters, I am convinced, Paul is arguing—and arguing theologically. We should not impose our own theological categories on Paul, but neither should we ignore those that he may be using.")]), _vm._v(" "), _c('p', [_vm._v("My own outline reflects what I think is the theme of the letter: the gospel. There is general agreement over the major sections of the letter, with one significant exception: the place of chap. 5. Many interpreters, especially in the Reformed Protestant tradition, made this chapter the conclusion to Paul’s argument about justification by faith in chaps. 1–4. But gaining in popularity has been the decision to take chap. 5 with chaps. 6–8, a part of Paul’s “two-age” presentation of Christian existence and hope. As I argue in the introduction to chaps. 5–8, I am are convinced that the latter alternative is correct.")]), _vm._v(" "), _c('p', {
    staticClass: "ah",
    attrs: {
      "id": "INTRO.9"
    }
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.33"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0004#rINTRO.9"
    }
  }, [_vm._v("IX. ANALYSIS OF ROMANS")])]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [_c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1"
    }
  }, [_vm._v("I. THE LETTER OPENING (1:1–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.1"
    }
  }, [_vm._v("A. PRESCRIPT (1:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.2"
    }
  }, [_vm._v("B. THANKSGIVING AND OCCASION: PAUL AND THE ROMANS (1:8–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY1.3"
    }
  }, [_vm._v("C. THE THEME OF THE LETTER (1:16–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY2"
    }
  }, [_vm._v("EXCURSUS: RIGHTEOUSNESS LANGUAGE IN ROMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3"
    }
  }, [_vm._v("II. THE HEART OF THE GOSPEL: JUSTIFICATION BY FAITH (1:18–4:25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1"
    }
  }, [_vm._v("A. THE UNIVERSAL REIGN OF SIN (1:18–3:20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.1"
    }
  }, [_vm._v("1. All Persons Are Accountable to God for Sin (1:18–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2"
    }
  }, [_vm._v("2. Jews Are Accountable to God for Sin (2:1–3:8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1"
    }
  }, [_vm._v("a. The Jews and the Judgment of God (2:1–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1.1"
    }
  }, [_vm._v("i. Critique of Jewish Presumption (2:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011#BODY3.1.2.1.2"
    }
  }, [_vm._v("ii. The Impartiality of Judgment (2:6–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.1.3"
    }
  }, [_vm._v("iii. Judgment and the Law (2:12–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2"
    }
  }, [_vm._v("b. The Limitations of the Covenant (2:17–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2.1"
    }
  }, [_vm._v("i. The Law (2:17–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.2.2"
    }
  }, [_vm._v("ii. Circumcision (2:25–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.2.3"
    }
  }, [_vm._v("c. God’s Faithfulness and the Judgment of Jews (3:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY3.1.3"
    }
  }, [_vm._v("3. The Guilt of All Humanity (3:9–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY4"
    }
  }, [_vm._v("Excursus: Paul, “Works of the Law,” and First-Century Judaism")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011a#BODY4.1"
    }
  }, [_vm._v("B. JUSTIFICATION BY FAITH (3:21–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.1"
    }
  }, [_vm._v("1. Justification and the Righteousness of God (3:21–26)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2"
    }
  }, [_vm._v("2. “By Faith Alone” (3:27–4:25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.1"
    }
  }, [_vm._v("a. “By Faith Alone”: Initial Statement (3:27–31)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2"
    }
  }, [_vm._v("b. “By Faith Alone”: Elaboration with Respect to Abraham (4:1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.1"
    }
  }, [_vm._v("i. Faith and Works (4:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.2"
    }
  }, [_vm._v("ii. Faith and Circumcision (4:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.3"
    }
  }, [_vm._v("iii. Faith, Promise, and the Law (4:13–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl4"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY4.1.2.2.4"
    }
  }, [_vm._v("iv. The Faith of Abraham and the Faith of the Christian (4:23–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5"
    }
  }, [_vm._v("III. THE ASSURANCE PROVIDED BY THE GOSPEL: THE HOPE OF SALVATION (5:1–8:39)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5.1"
    }
  }, [_vm._v("A. THE HOPE OF GLORY (5:1–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011b#BODY5.1.1"
    }
  }, [_vm._v("1. From Justification to Salvation (5:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Reign of Grace and Life (5:12–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. FREEDOM FROM BONDAGE TO SIN (6:1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY5.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. “Dead to Sin” through Union with Christ (6:1–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.34"
    }
  }), _vm._v("Excursus: Paul’s “With Christ” Conception")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Freed from Sin’s Power to Serve Righteousness (6:15–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. FREEDOM FROM BONDAGE TO THE LAW (7:1–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011c#BODY6.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Released from the Law, Joined to Christ (7:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The History and Experience of Jews under the Law (7:7–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Coming of the Law (7:7–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.2.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. Life under the Law (7:13–25)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. ASSURANCE OF ETERNAL LIFE IN THE SPIRIT (8:1–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Spirit of Life (8:1–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011d#BODY6.3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Spirit of Adoption (8:14–17)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY6.3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Spirit of Glory (8:18–30)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY6.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. THE BELIEVER’S SECURITY CELEBRATED (8:31–39)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. THE DEFENSE OF THE GOSPEL: THE PROBLEM OF ISRAEL (9:1–11:36)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. INTRODUCTION: THE TENSION BETWEEN GOD’S PROMISES AND ISRAEL’S PLIGHT (9:1–5)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. DEFINING THE PROMISE (1): GOD’S SOVEREIGN ELECTION (9:6–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Israel within Israel (9:6–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011e#BODY7.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Objections Answered: The Freedom and Purpose of God (9:14–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. God’s Calling of a New People: Israel and the Gentiles (9:24–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. UNDERSTANDING ISRAEL’S PLIGHT: CHRIST AS THE CLIMAX OF SALVATION HISTORY (9:30–10:21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Israel, the Gentiles, and the Righteousness of God (9:30–10:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a. The Righteousness of God and the “Law of Righteousness” (9:30–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b. The Righteousness of God and “Their Own Righteousness” (10:1–4)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl3"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c. Gospel and Law (10:5–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Israel’s Accountability (10:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. SUMMARY: ISRAEL, THE “ELECT,” AND THE “HARDENED” (11:1–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. DEFINING THE PROMISE (2): THE FUTURE OF ISRAEL (11:11–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. God’s Purpose in Israel’s Rejection (11:11–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011f#BODY7.5.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. The Interrelationship of Jews and Gentiles: A Warning to Gentile Believers (11:16–24)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY7.5.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Salvation of “All Israel” (11:25–32)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY7.6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "id": "page.35"
    }
  }), _vm._v("F. CONCLUSION: PRAISE TO GOD IN LIGHT OF HIS AWESOME PLAN (11:33–36)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. THE TRANSFORMING POWER OF THE GOSPEL: CHRISTIAN CONDUCT (12:1–15:13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. THE HEART OF THE MATTER: TOTAL TRANSFORMATION (12:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. HUMILITY AND MUTUAL SERVICE (12:3–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011g#BODY8.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. LOVE AND ITS MANIFESTATIONS (12:9–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D. THE CHRISTIAN AND SECULAR RULERS (13:1–7)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E. LOVE AND THE LAW (13:8–10)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("F. LIVING IN LIGHT OF THE DAY (13:11–14)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G. A PLEA FOR UNITY (14:1–15:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Do Not Condemn One Another! (14:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Do Not Cause Your Brother to Stumble! (14:13–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Put Other People First! (15:1–6)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY8.7.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Receive One Another! (15:7–13)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl"
  }, [_c('b', [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. THE LETTER CLOSING (15:14–16:27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011h#BODY9.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A. PAUL’S MINISTRY AND TRAVEL PLANS (15:14–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Looking Back: Paul’s Ministry in the East (15:14–21)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Looking Ahead: Jerusalem, Rome, and Spain (15:22–29)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.1.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Request for Prayer (15:30–33)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B. GREETINGS (16:1–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. Commendation of Phoebe (16:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Greetings to Roman Christians (16:3–16)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. A Warning, a Promise, and a Prayer for Grace (16:17–20)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl2"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.2.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Greetings from Paul’s Companions (16:21–23)")])]), _vm._v(" "), _c('p', {
    staticClass: "nl1"
  }, [_c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0011i#BODY9.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C. CONCLUDING DOXOLOGY (16:25–27)")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ee68b17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eernicnt66ro0009.vue
// module id = 78
// module chunks = 0